import env from "@/env.config";
import { authService } from "@/services";
import Axios from "axios";
import cookie from "./cookie";

const _axios = Axios.create({
	baseURL: env.baseApiUrl,
});

_axios.interceptors.request.use(
	(config) => {
		const uid = cookie.get(env.authKeyUid);
		const client = cookie.get(env.authKeyClient);
		const accessToken = cookie.get(env.authKeyToken);

		if (uid && client && accessToken) {
			config.headers.uid = uid;
			config.headers.client = client;
			config.headers["access-token"] = accessToken;
		}

		return config;
	},
	(err) => {
		return Promise.reject(err);
	},
);

_axios.interceptors.response.use(
	async (res) => {
		const uid = cookie.get(env.authKeyUid);
		const client = cookie.get(env.authKeyClient);
		const accessToken = cookie.get(env.authKeyToken);
		if (
			!uid &&
			!client &&
			!accessToken &&
			res.headers.uid &&
			res.headers.uid &&
			res.headers["access-token"]
		) {
			await authService.setToken(res.headers);
		}
		return res;
	},
	async (err) => {
		if (
			err.response?.status === 401 &&
			err.response?.config?.url?.includes("/api/v1/members/profile")
		) {
			await authService.clearToken();
			return window.location.replace("/");
		}
		return Promise.reject(err);
	},
);

export const axios = _axios;
